export default "__VITE_ASSET__BNh8ZBXu__"